"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.minify = void 0;
const isEqual_1 = __importDefault(require("lodash-es/isEqual"));
exports.minify = styles => {
    const output = [];
    styles.forEach(style => {
        const item = output.find(x => isEqual_1.default(style.settings, x.style));
        if (!item) {
            output.push({
                types: [style.scope],
                style: style.settings,
            });
        }
        else {
            item.types.push(style.scope);
        }
    });
    return output;
};
